import React from 'react';
import { Button, Col, Container, Form, Image, Row, Table } from 'react-bootstrap';
import Select from 'react-select';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { NavBarComponente } from '../../Components/NavBarComponente';
import "../../Estilo/Form.css";
import clearFilter from '../../Imagens/clear-filter.png';
import fechar from '../../Imagens/close-24.png';
import filtrar from '../../Imagens/filter-16.png';
import printer from '../../Imagens/printer.png';
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { GlobalViewModel } from '../Global/GlobalViewModel';
import { VectorQuantificationRelatoryViewModel } from './VectorQuantificationRelatoryViewModel';

interface MyProps {
    navigation: any
    delegate: VectorQuantificationRelatory
    viewModel: VectorQuantificationRelatoryViewModel
}

export interface VectorQuantificationRelatory {
    tapDimiss(navigation: any): void
}
export interface Filters {
    scamada: string;
    tipo: string;
    pagina: number;
}

export class VectorQuantificationRelatoryViewController extends React.Component<MyProps> {

    private globalViewModel = new GlobalViewModel()
    private formEvent: FormEvent


    state = {
        isLoading: true,
        json: {},
        data: Array<any>(),
        total: 0,
        clearValue: false,
        showFilter: false,
        vectorType: [
            { value: 'U', label: 'Urbano' },
            { value: 'R', label: 'Rural' },
            { value: 'C', label: 'Cemitério' },
            { value: 'D', label: 'Pontos diversos' },
        ],
        shapeList: [],
        filters: {
            scamada: '',
            tipo: '',
            pagina: 1
        },
        editingFilters: {
            scamada: '',
            tipo: '',
            pagina: 1
        },
        countPage: 1
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
    }

    componentDidMount() {
        this.loadData()
        this.setState({
            isLoading: false
        })
    }

    render() {
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Relatório Quantificação de Vetores</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row className="header">
                                <Col xs="12" className="containerFilter">
                                    <Row>
                                        <Col lg="4" xs="12" className="bottom10">
                                            <Form.Label>Camada</Form.Label>
                                            <Select
                                                id="scamada"
                                                key={this.state.clearValue ? 'reset' : 'normal'}
                                                value={this.state.editingFilters.scamada ? this.state.shapeList.find((option: any) => option.value === this.state.editingFilters.scamada) : null}
                                                onChange={(e: any) => this.verifyFilters('scamada', e ? e.value : '')}
                                                closeMenuOnSelect={true}
                                                placeholder={"Selecione"}
                                                options={this.state.shapeList}
                                                isClearable
                                            />


                                        </Col>
                                        {/* <Col lg="2" xs="12" className="bottom10">
                                            <Form.Label>Tipo</Form.Label>
                                            <Select
                                                id="tipo"
                                                value={this.state.filters.tipo ? this.formEvent.onValueSelect('select', 'type', this.state.vectorType) : null}
                                                onChange={(e: any) => this.verifyFilters('tipo', e ? e.value : null)}
                                                closeMenuOnSelect={true}
                                                placeholder={"Selecione"}
                                                options={this.state.vectorType}
                                                isClearable
                                            />
                                        </Col> */}
                                    </Row>
                                    <Row>
                                        <Col xs='12'>
                                            <Button
                                                onClick={() => {
                                                    this.setState({
                                                        filters: { ...this.state.editingFilters }
                                                    }, () => this.screenUpdate());
                                                }}
                                                variant="info"
                                                type="button"
                                                className="btnFilter right10">
                                                <Image className="iconBtnFilter" src={filtrar} />
                                                Filtrar
                                            </Button>
                                            <Button
                                                onClick={() => {
                                                    this.clearFilters()
                                                    this.setState({
                                                        clearValue: true
                                                    })
                                                }}
                                                variant="info"
                                                type="button"
                                                className="btnFilter">
                                                <Image
                                                    className="iconBtnFilter"
                                                    src={clearFilter} />
                                                Limpar
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>


                                <Col xs="12" className='mt-2'>
                                    <Button variant="danger" type="button" className="buttonGeneric colorRed"
                                        onClick={() => this.printRelatory(this.state.filters)}>
                                        <Image
                                            className="iconButtonGeneric"
                                            src={printer} />
                                        PDF
                                    </Button>
                                </Col>
                            </Row>
                            <>
                                <Table responsive hover style={{ textAlign: 'left', fontSize: 14, backgroundColor: "#ffffff" }}>
                                    <thead style={{ backgroundColor: "#eeeeee" }}>
                                        <tr>
                                            <th>Descrição</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.map((item, key) => (
                                            <tr key={key}>
                                                <td>{item.description}</td>
                                                <td>{item.valor}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </>

                        </Form>
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })} />
            </div>
        )
    }

    private printRelatory(filters: Filters) {
        this.setState({ isLoading: true });
        this.props.viewModel.fetchVectorQuantificationRelatory(filters).then(() => {
            this.setState({ isLoading: false });
        })
    }

    private loadData() {
        this.screenUpdate()
        this.lists()

    }
    private screenUpdate() {
        this.setState({ isLoading: true })
        this.props.viewModel.fetchVectorQuantification(this.state.filters).then((response: any) => {
            if (response.dados.length) {
                this.setState({
                    isLoading: false,
                    data: response.dados,
                })
            } else {
                this.setState({
                    isLoading: false,
                    data: [],
                })
            }
        })
    }

    private lists() {
        this.globalViewModel.fetchDataToSelectInput('camada', 'scamada', 'camada').then((response: any) => {
            if (response.length) {
                this.setState({
                    shapeList: [{ value: '0', label: 'Todas' }, ...response]

                })
            }
        })
    }

    private verifyFilters(key: keyof Filters, newValue: string) {
        let newEditingFilters = { ...this.state.editingFilters };
        newEditingFilters[key] = newValue as never;
        if (key !== 'pagina') newEditingFilters['pagina'] = 1;
        this.setState({ editingFilters: newEditingFilters });
    }


    private clearFilters() {
        this.setState({
            filters: {
                scamada: '',
                tipo: '',
                pagina: 1
            },
            editingFilters: {
                scamada: '',
                tipo: '',
                pagina: 1
            },
            clearValue: true
        }, () => {
            this.screenUpdate();
            setTimeout(() => {
                this.setState({ clearValue: false }); 
            }, 0);
        });
    }

}